export enum IDChangeSurname {
  nuovoCognome = '6',
  nuovoNome = '7',
  nuovoCognomeNome = '8',
  cognomeAggiunto = '9',
  nomeAggiunto = '10',
}
